export const mockUser = {
  uid: 'test-user-123',
  email: 'test@example.com',
  name: 'Test User',
};

export const mockUsersQueues = {
  queue1: {
    createdOn: '2025-03-30',
    description: 'Queue 1 description',
    hostId: 'nageeb.damani@gmail.com',
    id: 'queue1',
    limit: 'Unlimited',
    name: 'Queue 1',
    organizationId: 'org1',
    status: 'Active',
    userId: 'test-user-123',
    daily_stats: {
      '2024-04-01': {
        averageWaitTimePerPosition: 3,
        guests: {
          guestId1: {
            status: 'served',
            waitTime: 5,
            startedPosition: 1,
          },
          guestId2: {
            status: 'canceled',
            startedPosition: 2,
            position: 1,
          },
          guestId3: {
            status: 'served',
            startedPosition: 3,
            position: 2,
          },
        },
      },
      '2024-04-02': {
        averageWaitTimePerPosition: 17.6,
        guests: {
          guestId1: {
            status: 'served',
            waitTime: 5,
            startedPosition: 1,
          },
          guestId2: {
            status: 'canceled',
            startedPosition: 2,
            position: 1,
          },
          guestId3: {
            status: 'waiting',
            startedPosition: 3,
            position: 2,
          },
          guestId4: {
            status: 'waiting-notified',
            startedPosition: 4,
            position: 3,
          },
        },
      },
    },
  },
};

export const mockUsersOrgs = {
  org1: {
    orgName: 'Organization One',
    ownerId: 'test-user-123',
  },
};
